export default "__VITE_ASSET__C7ka30mY__"